'use strict';
/*
 * Module: fetchtv.Directives
 * Directive: minimumCharacterMatch
 * Custom validator that ensures a minimum number of matches against matchPattern
 */
(function(angular) {
  angular.module('fetchtv.Directives')
    .directive('minimumCharacterMatch', [function() {
      return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
          matchPattern: '@',
          matchMinimum: '@'
        },
        compile: function() {
          function postLink(scope, iElement, iAttrs, controller) {
            var minCount = parseInt(scope.matchMinimum, 10),
              matcher = new RegExp(scope.matchPattern);
            controller.$parsers.unshift(function(value) {
              if (angular.isDefined(value)) {
                var count = value.split("")
                  .reduce(function(currentCount, character) {
                    return matcher.test(character) ? currentCount + 1 : currentCount;
                  }, 0);
                var isValid = count >= minCount;
                controller.$setValidity('minimumCharacters', isValid);
                return isValid ? value : undefined;
              }
            });
          }
          return {
            post: postLink
          };
        }
      };
    }]);
})(angular);

